import type { DefinedMessage } from '@transcend-io/internationalization';

/**
 * Get purpose description message
 *
 * @param purpose - Purpose tracking type string
 * @param type - The type of message (title or description)
 * @returns The correct message to use for a given purpose
 */
export function getPurposeMessage(
  purpose: string,
  type: 'title' | 'description',
): DefinedMessage {
  const purposeMessage: DefinedMessage = {
    id:
      type === 'title'
        ? `purpose.trackingType.${purpose}.uiTitle`
        : `purpose.trackingType.${purpose}.${type}`,
    defaultMessage: purpose,
    description: `${purpose} ${type}`,
  };
  return purposeMessage;
}
